const getUrl = (...params: (string | number | undefined | null)[]) => {
    return params.filter(Boolean).join('/');
};
export default getUrl;
